module.exports = __webpack_public_path__ + "static/img/fc.730f105.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fc.png
// module id = UdSD
// module chunks = 1